import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import parse from "html-react-parser";
import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MICROSITE_CONNECT_ACCOUNT_FAILED, MICROSITE_CONNECT_ANOTHER_ACCOUNT, MICROSITE_CONNECT_TRY_AGAIN, trackEvent } from "../../analytics";
import { AttentionBox, Background, FullScreenLoader, InvertedPrimaryButton, NavBar, PrimaryButton } from "../../Components";
import Icons from "../../Components/Icons/icons";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { getWorkplatformDetails } from "../../utils/api";
import { ABANDONED_PAGE_CONTENT, CONNECTED_STORAGE_WORK_PLATFORM_ID, STORAGE_AUTH_DATA, STORAGE_AUTH_TENANT_APP_NAME, STORAGE_WORK_PLATFORM_ID, STORAGE_WORK_PLATFORM_NAME } from "../../utils/constants";
import { launchSDK, navigateToPlatformEducationPage } from "../../utils/helpers";
import "./AbandonedPage.scss";

function AbandonedPage() {
  const [loader, setLoader] = useState(false);
  const [workplatformName, setWorkplatformName] = useState("");
  const navigate = useNavigate();
  const onlyOnce = useRef(true);
  const [appName, setAppName] = useState();

  useEffect(() => {
    (async () => {
      const auth = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
      if (onlyOnce.current) {
        onlyOnce.current = false;
        const workPlatformName = sessionStorage.getItem(STORAGE_WORK_PLATFORM_NAME);
        setWorkplatformName(workPlatformName)
        trackEvent(MICROSITE_CONNECT_ACCOUNT_FAILED, { creator_user_id: auth?.user_id, workPlatformName });
      }
      setAppName(auth[STORAGE_AUTH_TENANT_APP_NAME]);
    })();
  }, []);

  return (
    <>
      <Background>
        <Box className="success-page-body">
          <Box className="success-page-header" >
            <label> {ABANDONED_PAGE_CONTENT.header} </label>
            <Box className="circular-icon" > {ABANDONED_PAGE_CONTENT.icon} </Box>
          </Box>
          <Box className="attention-box-container">
            <AttentionBox content={ABANDONED_PAGE_CONTENT.abandonedAttentionMsg} />
          </Box>
          {appName && <Box className="contact-info">
            {ABANDONED_PAGE_CONTENT?.contactInfo?.map((data, index) => (
              <p key={index}> {parse(data.replace("appName", appName))} </p>
            ))}
          </Box>}
          <Box className="button-group">
            <PrimaryButton
              onClick={() => {
                trackEvent(MICROSITE_CONNECT_TRY_AGAIN, { work_platform_name: workplatformName });
                navigateToPlatformEducationPage(navigate);
              }}
              htmlType="submit"
              label="Retry connection"
            />
            <InvertedPrimaryButton
               onClick={() => {
                trackEvent(MICROSITE_CONNECT_ANOTHER_ACCOUNT, { work_platform_name: workplatformName });
                navigate(ROUTE_LANDING_PAGE);
              }}
            label={<> <Icons.add_other_platforms/> Connect another account</>}
            />
          </Box>
        </Box>
      </Background>
    </>
  );
}

export default AbandonedPage;
